import { RootState } from "../../rootReducer";

export const selectIsDeletingStressCheck = (state: RootState) =>
  state.deleteStressCheck.loading;
export const selectIsDeleted = (state: RootState) =>
  state.deleteStressCheck.deleted;
export const selectDeleteErrorMessage = (state: RootState) =>
  state.deleteStressCheck.error;
export const deleteStressCheckDataResponse = (state: RootState) =>
  state.deleteStressCheck.deleteStressCheckResponse;
